var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 mx-1",staticStyle:{"width":"calc(100% - 5px)"}},[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticStyle:{"border":"1px solid lightblue","border-radius":"2px","padding":"10px"}},[_c('span',{staticStyle:{"margin":"5px"}},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }